import React, { useContext } from 'react';
import { bool } from 'prop-types';
import { ToolContext } from '../../context/tool-context';

import './deposit-callout.scss';

export const DepositCallout = ({ depositCalloutReduced, isRentalClearTool, isDeliveryFlow }) => {
  const tool = useContext(ToolContext);
  const isAVehicle = tool.isAVehicle();
  const isALargeEquipment = tool.isALargeEquipment();
  const isHoistingLicenseRequired = tool.isHoistingLicenseRequired();

  const toggleIdentification = () => {
    if (isAVehicle) {
      return 'Driver\'s License and Proof of Insurance';
    }
    if (isALargeEquipment) {
      return 'Driver\'s License';
    }
    return 'identification';
  };

  const ReducedDepositCallout = () => (
    <div>
      Your deposit or total will be calculated at checkout. Credit Cards accepted. No Cash.
    </div>
  );

  const DeliverFlowCallout = () => (
    <>
      <div className="rental-deposit__line-item">
        Your payment will be calculated at checkout. Credit Cards accepted. No Cash.
      </div>
      <div className="rental-deposit__line-item">
        A&nbsp;<b>valid {toggleIdentification()}</b>&nbsp;is required to rent
        {/* eslint-disable-next-line max-len */}
        {isHoistingLicenseRequired ? ', and in Massachusetts, evidence of a hoisting license is also required.' : '.'}
      </div>
      {isRentalClearTool && (
        <div className="rental-deposit__line-item">
          {/* eslint-disable-next-line max-len */}
          Except for select states,&nbsp;<b>CLEAR</b>&nbsp;verification required using a&nbsp;<b>valid Driver&apos;s License</b>.
        </div>
      )}
      <div className="rental-deposit__line-item">Models vary based on location and availability.</div>
    </>
  );

  return (
    <div className="rental-deposit">
      {isDeliveryFlow && <DeliverFlowCallout /> }
      {!isDeliveryFlow && depositCalloutReduced && <ReducedDepositCallout /> }
      {!isDeliveryFlow && !depositCalloutReduced && (
        <>
          <div className="rental-deposit rental-deposit__line-item">
            Your deposit or total will be calculated at checkout.
            Credit Cards accepted. No Cash.
          </div>
          <div className="rental-deposit__line-item">
            A&nbsp;<b>valid {toggleIdentification()}</b>&nbsp;is required to rent
            {/* eslint-disable-next-line max-len */}
            {isHoistingLicenseRequired ? ', and in Massachusetts, evidence of a hoisting license is also required.' : '.'}
          </div>

          {isRentalClearTool && (
            <div className="rental-deposit__line-item">
              {/* eslint-disable-next-line max-len */}
              Except for select states,&nbsp;<b>CLEAR</b>&nbsp;verification required using a&nbsp;<b>valid Driver&apos;s License</b>.
            </div>
          )}

          {isAVehicle && (
            <>
              <div className="rental-deposit__line-item">Environmental fee may apply.</div>
              {/* eslint-disable-next-line max-len */}
              <div className="rental-deposit__line-item">Customers are responsible for&nbsp;<b>refueling vehicle</b>.</div>
              {/* eslint-disable-next-line max-len */}
              <div className="rental-deposit__line-item">Vehicles must be returned to the&nbsp;<b>same pickup location</b>.</div>
            </>
          )}

          {!isAVehicle && !isALargeEquipment && (
            <div className="rental-deposit__line-item">This tool may require accessories.</div>
          )}

          {!isALargeEquipment && (
            <div className="rental-deposit__line-item">For more details, please call your nearest Rental Center.</div>
          )}
        </>
      )}
    </div>
  );
};

DepositCallout.displayName = 'DepositCallout';

DepositCallout.propTypes = {
  depositCalloutReduced: bool.isRequired,
  isRentalClearTool: bool.isRequired,
  isDeliveryFlow: bool.isRequired
};
